import TaskPanelContainer from '../TaskPanelContainer'
import CreateTaskPanel from './CreateTaskPanel'
import {connect} from '../../../redux/utils'
import {isLoading, isNeedToLoadData, isPanelOpened} from './selectors'
import {cancelTaskCreation, closeCreateTaskPanel, loadCreateTaskPanelData, openCreateTaskPanel} from './actions'
import {bindActionCreators} from 'redux'
import {PANEL_TYPES} from '../../constants'

class CreateTaskPanelContainer extends TaskPanelContainer {
    constructor({
        openPanel = () => {},
        onPanelHideCb = () => {},
        loadPanelData = () => {},
        hideHandler = () => {},
    }) {
        super({
            additionalClass: 'create_task_sliding_panel sliding_panel',
            panelContent: new CreateTaskPanel({
                canEdit: true,
                showReportTab: false,
                showCreateFooter: true,
                showEmptyTaskNameInput: true,
                dateFormat: Date.convertSmartToExtDateFormat(window.SystemSettings.dateFormat).replace(/F/, "M"),
            }),
            panelType: PANEL_TYPES.CREATE_TASK,
            needToHideOnOutsideClick: false,
            needShowMoire: true,
            showCopyLink: false,
            openPanel,
            loadPanelData,
            onPanelHideCb,
            hideHandler,
        })
    }
}

export default connect(
    state => ({
        isShown: isPanelOpened(state),
        needToLoadData: isNeedToLoadData(state),
        loading: isLoading(state),
    }),
    dispatch => ({
        openPanel: bindActionCreators(openCreateTaskPanel, dispatch),
        onPanelHide: bindActionCreators(closeCreateTaskPanel, dispatch),
        loadPanelData: bindActionCreators(loadCreateTaskPanelData, dispatch),
        hideHandler: bindActionCreators(cancelTaskCreation, dispatch),
    })
)(CreateTaskPanelContainer)


// WEBPACK FOOTER //
// ./web/js/panels/task/createPanel/CreateTaskPanelContainer.js